import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { MembershipAwarenessFormData as MembershipAwarenessFormDataType } from '../types';

import {
	MembershipAwarenessFormData,
	type MembershipAwarenessFormDataQuery,
	type MembershipAwarenessFormDataQueryVariables,
} from './getMembershipFormData.graphql';
import { normalize } from './normalize';

export async function getMembershipFormData(utilityContext: UtilityContext): Promise<MembershipAwarenessFormDataType> {
	const {
		gql: { fetch },
	} = utilityContext;

	// FIXME data retrieval should be done at the page level
	const { data } = await fetch<MembershipAwarenessFormDataQuery, MembershipAwarenessFormDataQueryVariables>({
		query: MembershipAwarenessFormData,
		rejectOnError: true,
	});

	return normalize(utilityContext, data);
}
